module.exports = __webpack_public_path__ + "img/made-by-dawsat.bba80625.png";